import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_VEHICLE_IN_INCIDENT = gql`
  mutation addOrUpdateVehicleInIncident($input: AddOrUpdateVehicleInIncidentInput!) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        uuid
        id
        abandoned
        impounded
        operator {
          id
        }
        reasonSeized {
          id
          oriId
          position
          name
        }
        suspectDriven
        wrecker {
          id
          oriId
          position
          name
        }
        towingDestination {
          id
          oriId
          position
          name
        }
        usedInCrime
        vehicle {
          id
          uuid
          description
          owner {
            id
          }
          plateType {
            id
            oriId
            name
            position
          }
          value
          vehicleColor {
            id
            oriId
            name
            position
          }
          vehicleMake {
            id
            nhtsaId
            oriId
            name
            position
          }
          vehicleModel {
            id
            nhtsaId
            oriId
            name
            position
          }
          vehiclePlate {
            id
            oriId
            name
            position
          }
          vehicleState {
            id
            oriId
            name
            position
          }
          vehicleVin {
            id
            oriId
            name
            position
          }
          validVehicleAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            officerId
            vehicle {
              id
            }
          }
          year
        }
        vehicleOfInterest
        vehicleRole {
          id
          oriId
          position
          name
        }
      }
    }
  }
`